import { get, isEmpty } from "lodash";
import { format } from 'redux-form-validators';
import React from "react";

export const membershipType = [
    { id: 'standard', text: 'STANDARD MEMBERSHIP' },
    { id: 'plantagenet', text: 'PLANTAGENET MEMBERSHIP (single)' },
    { id: 'plantagenet_double', text: 'PLANTAGENET MEMBERSHIP (double)' },
    { id: 'student', text: 'STUDENT MEMBERSHIP (FREE)' },
    { id: 'teacher', text: 'TEACHER MEMBERSHIP (FREE)' }
]

export const membershipPlanList = (list = [], skip = "") => {
    let val = [];
    if (list.length > 0) {
        list.forEach(plan => {
            if (plan && plan.id) {
                if (skip !== plan.id) {
                    val.push({ id: plan.id, text: `${plan.colored_title} ${plan.normal_title}`, additionalText: plan.is_double_user ? plan.is_double_user === 0 ? '(Single)' : '(Double)' : '' });
                }
            }
        });
    }
    return val;
}

export const ageRange = [
    { id: '18-25', text: '18 - 25' },
    { id: '26-30', text: '26 - 30' }
]

export const postcodeValidator = (countryCode, countryValues = []) => {
    let regex = "";

    if (!isEmpty(countryValues)) {
        const country = countryValues.find(eachCountry => get(eachCountry, "id", "") === countryCode);

        if (country) {
            regex = new RegExp(get(country, "postcode_regex", ""), "i");
        }
    }

    return format({ with: regex, message: "Invalid Postcode", allowBlank: false });
}

export const membershipKeys = {
    student: "student",
    teacher: "teacher",
}

export const endpoints = {
    confirmConsent: "confirm-consent",
    rejectConsent: "reject-consent"
}

export const isMinorUser = ({ age, country, membershipKey, countryValues = [] }) => {
    let isMinor = false;
    if (membershipKey === membershipKeys.student) {
        isMinor = age && parseInt(age) <= 12;
        if (age && country) {
            countryValues.forEach((eachCountry) => {
                if (eachCountry.id === country) {
                    isMinor = parseInt(age) <= eachCountry.age_restriction;
                    return;
                }
            })
        }
    }
    return isMinor;
}

export const areaOfInterest = [
    { id: "interest_one", text: "Interest One" },
    { id: "interest_two", text: "Interest Two" }
]

export const theme = [
    { id: "theme_one", text: "Theme One" },
    { id: "theme_two", text: "Theme Two" }
]

export const Media = [
    { id: "media_one", text: "Media One" },
    { id: "media_two", text: "Media Two" }
]

export const memberBenefitsPlatforms = [
    {
        title: 'Adding an RSS Feed to Apple Podcasts',
        steps: [
            "<b>Open Apple Podcasts App:</b> Launch the Apple Podcasts app on your iPhone, iPad, or Mac.",
            '<b>Navigate to Library:</b> Tap on the "Library" tab at the bottom of the screen.',
            '<b>Add a Podcast by URL:</b> <br />On iPhone/iPad: Tap "Edit" in the top right corner, then "Add a Show by URL.<br />On Mac: Go to "File" in the top menu, then select "Add a Show by URL."',
            '<b>Enter RSS Feed URL:</b> Paste the RSS feed URL into the input field and tap "Subscribe."',
            '<b>Confirm Subscription:</b> The podcast will now appear in your library, and new episodes will automatically download'
        ],
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clipPath="url(#clip0_4358_54572)">
                <path d="M25.01 0H6.98995C3.12951 0 0 3.12951 0 6.98995V25.01C0 28.8705 3.12951 32 6.98995 32H25.01C28.8705 32 32 28.8705 32 25.01V6.98995C32 3.12951 28.8705 0 25.01 0Z" fill="url(#paint0_linear_4358_54572)" />
                <path d="M17.8977 18.7518C17.8663 18.4722 17.7719 18.2695 17.5867 18.0808C17.2372 17.7138 16.6221 17.4727 15.8986 17.4727C15.1752 17.4727 14.56 17.7068 14.2105 18.0808C14.0323 18.2765 13.9309 18.4722 13.8995 18.7518C13.8366 19.297 13.875 19.7654 13.9379 20.5203C14.0008 21.2367 14.1162 22.1944 14.2665 23.1625C14.3748 23.8545 14.4622 24.2319 14.5391 24.4941C14.6719 24.9309 15.1472 25.3049 15.9021 25.3049C16.657 25.3049 17.1393 24.9239 17.2652 24.4941C17.342 24.2284 17.4294 23.8545 17.5378 23.1625C17.6846 22.1874 17.8034 21.2367 17.8663 20.5203C17.9362 19.7654 17.9676 19.297 17.9047 18.7518H17.8977Z" fill="white" />
                <path d="M17.8104 14.7742C17.8104 15.8332 16.9541 16.693 15.8951 16.693C14.8361 16.693 13.9799 15.8367 13.9799 14.7742C13.9799 13.7117 14.8361 12.8555 15.8951 12.8555C16.9541 12.8555 17.8104 13.7222 17.8104 14.7742Z" fill="white" />
                <path d="M15.8742 7.22267C11.4041 7.23665 7.74484 10.8714 7.68193 15.345C7.6365 18.9693 9.94668 22.0693 13.1795 23.2087C13.2564 23.2401 13.3368 23.1702 13.3263 23.0934C13.2879 22.8138 13.2389 22.5307 13.211 22.2511C13.197 22.1497 13.1341 22.0728 13.0467 22.0239C10.4919 20.909 8.70946 18.3437 8.74091 15.3764C8.77936 11.4795 11.9563 8.30611 15.8427 8.27465C19.8235 8.2432 23.0703 11.4691 23.0703 15.4463C23.0703 18.3856 21.2949 20.909 18.7645 22.0239C18.6701 22.0623 18.6072 22.1497 18.6002 22.2511C18.5618 22.5307 18.5233 22.8138 18.4849 23.0934C18.4709 23.1807 18.5548 23.2401 18.6317 23.2087C21.8331 22.0868 24.1293 19.0322 24.1293 15.4463C24.1153 10.9099 20.4141 7.21568 15.8742 7.22267Z" fill="white" />
                <path d="M15.6855 9.94983C12.7741 10.0582 10.436 12.4662 10.3976 15.381C10.3731 17.2998 11.3307 18.9983 12.8021 20.0014C12.872 20.0468 12.9733 19.9944 12.9733 19.907C12.9489 19.5715 12.9489 19.2744 12.9664 18.9634C12.9733 18.862 12.9349 18.7677 12.858 18.6978C11.9633 17.8555 11.4181 16.6567 11.4495 15.3321C11.5124 12.994 13.3893 11.0927 15.7239 10.9983C18.2612 10.897 20.3477 12.938 20.3477 15.4474C20.3477 16.7266 19.8025 17.8799 18.9393 18.6978C18.8694 18.7677 18.8309 18.862 18.8309 18.9634C18.8449 19.2674 18.8379 19.5645 18.8239 19.9C18.8169 19.9874 18.9183 20.0468 18.9952 19.9944C20.4421 19.0053 21.3997 17.3277 21.3997 15.4439C21.4067 12.3404 18.8135 9.82402 15.6855 9.94983Z" fill="white" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_4358_54572" x1="16" y1="0" x2="16" y2="32.0035" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F452FF" />
                    <stop offset="1" stopColor="#832BC1" />
                </linearGradient>
                <clipPath id="clip0_4358_54572">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    },
    // {
    //     title: 'Adding an RSS Feed to Spotify',
    //     steps: [
    //         "<b>Open Spotify App:</b> Launch the Spotify app on your mobile device or desktop.",
    //         '<b>Go to Your Library:</b> Tap on the "Your Library" tab at the bottom of the screen (mobile) or the left sidebar (desktop).',
    //         '<b>Navigate to Podcasts:</b> Select "Podcasts" from your library.',
    //         '<b>Add Podcast by URL:</b> <br />On Mobile: Tap the three dots in the top right corner, then "Add Podcast by URL."<br />On Desktop: Click on "Add a Podcast by URL" at the bottom of the podcasts section.',
    //         '<b>Enter RSS Feed URL:</b> Paste the RSS feed URL into the input field and tap "Add."',
    //         '<b>Confirm Subscription:</b> The podcast will now appear in your library, and new episodes will be available as they are released.'
    //     ],
    //     icon: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    //         <g clipPath="url(#clip0_4358_54543)">
    //             <path d="M16 0C7.1635 0 0 7.16362 0 16C0 24.837 7.16362 32 16 32C24.8371 32 32 24.837 32 16C32 7.16425 24.8371 0.000875 15.9998 0.000875L16 0ZM23.3374 23.0767C23.0508 23.5467 22.4355 23.6957 21.9655 23.4072C18.2089 21.1126 13.4799 20.5929 7.9105 21.8654C7.6526 21.9241 7.38195 21.8779 7.15805 21.7371C6.93415 21.5963 6.77533 21.3724 6.7165 21.1145C6.68719 20.9868 6.68334 20.8547 6.70519 20.7255C6.72703 20.5964 6.77413 20.4728 6.8438 20.3619C6.91347 20.2509 7.00433 20.1549 7.11118 20.0791C7.21803 20.0033 7.33877 19.9494 7.4665 19.9204C13.5615 18.5279 18.7894 19.1274 23.0069 21.7049C23.4769 21.9934 23.6259 22.6068 23.3374 23.0767ZM25.2957 18.7201C24.9345 19.307 24.1665 19.4924 23.58 19.1313C19.2793 16.4878 12.7234 15.7221 7.6365 17.2663C6.97675 17.4655 6.28 17.0938 6.07975 16.4351C5.881 15.7754 6.253 15.0799 6.91162 14.8794C12.7222 13.1161 19.946 13.9703 24.885 17.0053C25.4715 17.3665 25.6569 18.1344 25.2957 18.7201ZM25.4639 14.1835C20.3071 11.1205 11.7992 10.8387 6.87587 12.3333C6.08525 12.573 5.24913 12.1266 5.00962 11.336C4.77 10.545 5.21587 9.7095 6.00712 9.46912C11.6588 7.75338 21.0543 8.085 26.9911 11.6095C27.7039 12.0315 27.9369 12.95 27.5146 13.6601C27.0944 14.3714 26.1734 14.6058 25.4646 14.1835H25.4639Z" fill="#1ED760" />
    //         </g>
    //         <defs>
    //             <clipPath id="clip0_4358_54543">
    //                 <rect width="32" height="32" fill="white" />
    //             </clipPath>
    //         </defs>
    //     </svg>
    // },
    {
        title: 'Adding an RSS Feed to iTunes',
        steps: [
            "<b>Open iTunes:</b> Launch iTunes on your computer.",
            '<b>Navigate to Podcasts:</b> Click on the "Podcasts" tab from the dropdown menu in the top left corner.',
            '<b>Add Podcast by URL:</b> <br />Go to "File" in the top menu.<br />Select "Subscribe to Podcast..."',
            '<b>Enter RSS Feed URL:</b> Paste the RSS feed URL into the input field and tap "Subscribe."',
            '<b>Confirm Subscription:</b> The podcast will now appear in your library, and new episodes will automatically download as they are released.'
        ],
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M15.9714 1.98438C8.40412 1.98438 2.26996 8.11854 2.26996 15.6858C2.26996 23.2531 8.40412 29.3873 15.9714 29.3873C23.5387 29.3873 29.6729 23.2532 29.6729 15.6858C29.6729 8.11854 23.5387 1.98438 15.9714 1.98438ZM15.9714 3.49662C22.7025 3.49662 28.1607 8.95474 28.1607 15.6859C28.1607 22.417 22.7025 27.8751 15.9714 27.8751C9.24027 27.8751 3.79357 22.417 3.79357 15.6859C3.79357 8.95474 9.24027 3.49662 15.9714 3.49662Z" fill="url(#paint0_linear_4358_54559)" />
            <path d="M21.6809 6.54688L12.1795 9.11612H12.1685V12.9809H12.1795V19.8912C11.7638 19.641 11.2542 19.4925 10.7067 19.4925C9.29627 19.4925 8.15979 20.472 8.15979 21.6741C8.15979 22.8764 9.29659 23.8446 10.7067 23.8446C12.1167 23.8446 13.3152 22.8754 13.2649 21.6741L13.239 21.0575L13.1763 12.7038L20.6844 10.6771V18.3071C20.2461 18.0049 19.6865 17.8199 19.0788 17.8199C17.6684 17.8199 16.5315 18.7994 16.5315 20.0014C16.5315 21.2038 17.6684 22.172 19.0788 22.172C20.4891 22.172 21.6745 21.2038 21.6745 20.0014C21.6745 19.9901 21.6749 19.9795 21.6745 19.9681L21.6813 10.411V6.54688H21.6809Z" fill="url(#paint1_linear_4358_54559)" />
            <defs>
                <linearGradient id="paint0_linear_4358_54559" x1="15.958" y1="29.2771" x2="15.9847" y2="2.31499" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#BB5BFD" />
                    <stop offset="1" stopColor="#EB82D6" />
                </linearGradient>
                <linearGradient id="paint1_linear_4358_54559" x1="14.9139" y1="23.7751" x2="14.9354" y2="6.75558" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#BB5BFD" />
                    <stop offset="1" stopColor="#EB82D6" />
                </linearGradient>
            </defs>
        </svg>
    }
]

export const hasArticleLink = (coloredTitle) => {
    return [
        "History Club",
        "Festival Friends", 
        "Festival Friends with Club", 
        "Festival Friends without Club", 
        "Plantagenet Double", 
        "Plantagenet"
    ].includes(coloredTitle);
}